"use client";
import { useRef, useEffect, useState } from "react";

export default function StickyAudioPlayer({ audioSrc, label }) {
  const containerRef = useRef(null);
  const audioWrapperRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setIsSticky(rect.bottom < 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Placeholder to track scroll position */}
      <div ref={containerRef} className="max-w-2xl mx-auto">
        <div
          ref={audioWrapperRef}
          className={isSticky
            ? "fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 shadow-[0_-4px_20px_rgba(0,0,0,0.15)] border-t border-gray-200 dark:border-gray-700 p-3"
            : "bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-4"
          }
        >
          <audio
            controls
            preload="metadata"
            src={audioSrc}
            className="w-full"
          >
            Your browser does not support the audio element.
          </audio>
        </div>
        {/* Spacer when sticky */}
        {isSticky && <div className="h-[54px] bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl invisible"></div>}
      </div>
    </>
  );
}
